<mat-form-field
  [appearance]="appearance || 'legacy'"
  [floatLabel]="label ? 'auto' : 'always'"
  class="w-full emails-list"
>
  <mat-label>{{ label }}</mat-label>
  <mat-chip-list #emailList>
    <mat-chip
      class="email-mat-chip"
      *ngFor="let email of emails"
      [selectable]="true"
      [removable]="true"
      color="raised"
      selected
      [disabled]="disable || readonly"
      (removed)="remove(email); onTouched()"
    >
      <span class="email-ellipsis">{{ email }}</span>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>
  <input
    fbDisableAutocomplete
    matInput
    [matChipInputFor]="emailList"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="addOnBlur"
    [placeholder]="!disable ? placeholder : ''"
    [formControl]="emailControl"
    [fbDisableControl]="disable"
    [readonly]="readonly"
    (matChipInputTokenEnd)="add($event)"
    (focusout)="onTouched()"
    (keydown)="onKeyDown($event)"
  />
</mat-form-field>
